export interface InfiniteScrollObserverConfig {
  target?: Element | null;
  previousObserver?: IntersectionObserver | null;
  onIntersect: (entry: IntersectionObserverEntry) => void;
  options?: IntersectionObserverInit;
}

export function createInfiniteScrollObserver(config: InfiniteScrollObserverConfig): IntersectionObserver | undefined {
  const { target, previousObserver, onIntersect, options = { threshold: 0.1, rootMargin: '100px' } } = config;

  previousObserver?.disconnect();

  if (typeof IntersectionObserver === 'undefined' || !target) {
    return undefined;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        onIntersect(entry);
      }
    });
  }, options);

  observer.observe(target);
  return observer;
}

